import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, ModalController, AlertController, App } from 'ionic-angular';
import { StatusBar, Splashscreen } from 'ionic-native';
import { APP_ROUTES_SERVICE } from './app.routes';
import { MenuService } from '../providers/menu-service';
import { LoginService } from '../providers/login-service';
import { UsuarioService } from '../providers/usuario-service';
import { AlertService } from '../providers/alert-service';

import { AjudaPage } from '../pages/ajuda/ajuda';
import { environment } from '../environments/environment';

@Component({
  templateUrl: 'app.html',
  providers: [
    APP_ROUTES_SERVICE,
    MenuService,
    LoginService
  ]
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  pages: any;
  content: any;
  listaRotas: any = [];
  usuarioLogado: boolean = false;
  isJurisdicionado: boolean = false;

  constructor(private platform: Platform,
    public app: App,
    private _rotas: APP_ROUTES_SERVICE,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private menuService: MenuService,
    private loginService: LoginService,
    private alertService: AlertService,
    private usuarioService: UsuarioService
  ) {
    this.inicializeApp();

    this.rootPage = _rotas.obtemPaginaLoginComponent();

    this.listaRotas = this._rotas.obtemListaRotas();

    usuarioService.usuarioSetado.subscribe(dadosUsuario => {
      this.usuarioLogado = dadosUsuario.logado;
      this.isJurisdicionado = usuarioService.isJurisdicionado();
      if (this.usuarioLogado) {
        this.openPage(this._rotas.obtemPaginaPrincipal());
      }
    });   

    menuService.redirecionarPara.subscribe(idSecaoPagina => {
      let pagina = this.buscarPaginaCompleta(idSecaoPagina);

      if (pagina != null) {
        this.openPage(pagina);
      }
    })

    menuService.redirecionarParaSub.subscribe(dados => {

      let pagina = this.buscarSubPaginaCompleta(dados);
      if (pagina != null) {
        //this.nav.push(pagina.Component, { analise: dados.analise });
        this.openPage(pagina, { analise: dados.analise });
      }
    })
  }

  buscarPaginaCompleta(idSecaoPagina) {

    let paginaEncontrada = null;

    let rotaPCA = this.listaRotas.filter(rota => rota.Titulo == "Pca")[0];
    if (rotaPCA != null) {
      paginaEncontrada = rotaPCA.Paginas.filter(pagina => pagina.Autorizacao == idSecaoPagina)[0];
    }

    return paginaEncontrada;
  }

  buscarSubPaginaCompleta(dados) {

    let idSecaoPagina, cdAnalise;

    idSecaoPagina = dados.idSecaoPagina;
    cdAnalise = dados.analise.cdAnalise;

    let paginaEncontrada = null;

    let rotaPCA = this.listaRotas.filter(rota => rota.Titulo == "Pca")[0];

    if (rotaPCA != null) {
      let rotasPagina = rotaPCA.Paginas.filter(rota => rota.Autorizacao == idSecaoPagina)[0];

      if (rotasPagina != null) {
        if (cdAnalise != 0) {
          paginaEncontrada = rotasPagina.Paginas.filter(pagina => pagina.Autorizacao == cdAnalise)[0];
        } else {
          paginaEncontrada = rotasPagina;
        }
      }
    }

    return paginaEncontrada;
  }

  logout(forced = false) {
    if (!forced) {
      this.alertService.mostraModalConfirmacao("Até breve...", "Deseja realmente sair ?", callback => {
        if (callback) {
          if (this.usuarioService.isJurisdicionado()) {
            this.openPageFromComponent(this._rotas.obtemPaginaLoginComponent());
          }
          else {
            this.openPageFromComponent(this._rotas.obtemPaginaLoginComponent());
          }

          this.usuarioService.setUsuario();
        }
      })
    } else {
      this.openPageFromComponent(this._rotas.obtemPaginaLoginComponent());
      this.usuarioService.setUsuario();
    }
  }

  inicializeApp() {
    this.platform.ready().then(() => {
      StatusBar.styleDefault();
      Splashscreen.hide();
      this.inicializarGoogleAnalytics();
    });
  }

  private inicializarGoogleAnalytics() {
    if (environment.production && environment.googleAnalyticsTrackingId) {
      const gaId = environment.googleAnalyticsTrackingId;
      try {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(script);

        const inlineScript = document.createElement('script');
        inlineScript.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}');
        `;
        document.head.appendChild(inlineScript);
      } catch (e) {
        console.error('Erro ao inicializar Google Analytics:', e);
      }
    }
  }

  openPage(pagina, params = undefined) {
    this.nav.setRoot(pagina.Component, params);
  }

  openPageFromComponent(paginaComponent) {
    this.nav.setRoot(paginaComponent);
  }

  mostrarAlerta(titulo, subtitulo) {
    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: subtitulo,
      buttons: ['Confirmar']
    });
    alert.present();
  }

  ajuda() {
    let titulo = "Ajuda";

    let modal = this.modalCtrl.create(AjudaPage,
      {
        titulo: titulo
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
      }
    });

    modal.present();
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts